import { useEffect, useState } from "react"
import { Box, Button, LinearProgress, Tooltip, Typography } from "@mui/material"
import _ from 'lodash'
import { AppButton, Breadcrumb, Cards, CustomDialog, DisplayMessage, Loader, StatusButton, TableOutline } from "../../components"
import { ALL, applicationStatus, statusMapper, tableApplicationStatus, tableHeadings } from "./constant"
import { useStyles } from './style'
import { styled } from '@mui/material/styles'
import * as messageTypes from '../../utils/messageTypes'
import { applicationsService } from "../../services"
import { downloadFile } from '../../utils/fileUtils'
import Process from "./Process"
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import { dashboardService } from "../../services/DashboardService"
import downloadFileIcon from '../../assets/Images/downloadFile.svg'
import download from '../../assets/Images/download.svg'
import processFlow from '../../assets/Images/processFlow.svg'
import { FAMILY_KEY, PROGRAM_KEY } from "../../constants/common"
import { ENROLLMENT_FORMS, pdfFiles, PROGRAMDETAILS_FILES, TANDC_FORMS } from "../../constants/files"
import moment from "moment-timezone"
import { timeZone, timeZoneAbbrs } from '../../utils/momentTimezones'
import { navToLogin } from "../../utils/common"
import { linearProgressClasses } from '@mui/material/LinearProgress'
import ProgramClosureModal from "./ProgramClosureModal"

moment.fn.zoneName = function () {
  const abbr = this.zoneAbbr()
  return timeZoneAbbrs[abbr] || abbr
}

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#EDEDED',
  },
}))

const Applications = (props) => {
  const classes = useStyles()

  const [tableData, setTableData] = useState([])
  const [totalCount, setTotalCount] = useState(0)
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState()
  const [loading, setLoading] = useState(false)
  const [headingStatus, setHeadingStatus] = useState(ALL)
  const [processOpen, setProcessOpen] = useState(false)
  const [program, setProgram] = useState()
  const [fileModal, setFileModal] = useState(false)
  const [urlProgram, setUrlProgram] = useState([])
  const [programClosure, setProgramClosure] = useState(false)
  const [programClosureModal, setProgramClosureModal] = useState(false)
  const search = _.get(props.location, 'search', {})
  const programId = new URLSearchParams(search).get('programs')

  const handleDropdownChange = (value) => {
    setHeadingStatus(value)
    setPage(1)
  }

  const handlePageChange = (newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value)
    setPage(1)
  }

  const getAllApplications = () => {
    setLoading(true)
    applicationsService.getAllApplications(programId, page - 1, rowsPerPage, statusMapper[program && program[0] && program[0].family_key ? program[0].family_key : program[0].program_key] && statusMapper[program && program[0] && program[0].family_key ? program[0].family_key : program[0].program_key][headingStatus], program)
      .then(applicationsData => {
        setLoading(false)
        setApplicationTable(applicationsData.applications_info)
        setTotalCount(applicationsData.total_count)
      })
      .catch(error => {
        setLoading(false)
        if (error.status === 403) {
          navToLogin()
        } else {
          setOpen(true)
          setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
          setMessageType(messageTypes.ERROR)
        }
      })
  }

  const getProgram = () => {
    const programIds = programId?.split(',')
    setLoading(true)
    // programIds.forEach(programId => {
    dashboardService.getAllPrograms()
      .then(programsData => {
        setLoading(false)
        let filteredPrograms = programsData.filter(program => program.feature_flags && program.feature_flags.installer_intake && programIds.includes(program.id))
        setUrlProgram(new URLSearchParams({ programs: filteredPrograms.map(obj => obj.id) }))
        setProgram(filteredPrograms)
        const programClosure = filteredPrograms && filteredPrograms[0] && filteredPrograms[0].program_key === PROGRAM_KEY.APS_RBP ? true : false
        setProgramClosureModal(programClosure)
        setProgramClosure(programClosure)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })

    // dashboardService.getProgramsById(programIds[0])
    //   .then(programsData => {
    //     // let programsDetail = [...program]
    //     // programsDetail.push(programsData)
    //     setLoading(false)
    //     setProgram(programsData)
    //   })
    //   .catch(error => {
    //     setLoading(false)
    //     setOpen(true)
    //     setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
    //     setMessageType(messageTypes.ERROR)
    //   })
    // })
  }

  const getSiteIdField = (obj) => {
    if (!obj.site_id && obj.application_status === 'Application_Approved') {
      return <Box className={classes.link} display="flex" alignItems="center" onClick={() => props.history.push({ pathname: `/applications/${obj.program_id ? obj.program_id : programId}/view-application/${obj.application_id}`, state: { siteModal: true } })}>Enter Enphase Site ID <KeyboardArrowRightIcon sx={{ fontSize: '20px' }} /></Box>
    }
    return <Box>{_.get(obj, 'site_id', '') ? obj.site_id : '---'}</Box>
  }

  const setApplicationTable = (applicationsData) => {
    let applicationsTable = []
    applicationsData.map(obj => {
      let tableObj = [
        {
          id: 'applicationId',
          className: `${classes.idInTable} ${classes.centerAlign}`,
          value: <Box className={classes.link} onClick={() => props.history.push(`/applications/${obj.program_id ? obj.program_id : programId}/view-application/${obj.application_id}`)}>{_.get(obj, 'application_id', '')}</Box>,
        },
        {
          id: 'enphaseSiteId',
          className: classes.idInTable,
          value: getSiteIdField(obj),
        },
        ...(program && program[0] && program[0].program_key === PROGRAM_KEY.PSEG_LI) ? [{
          id: 'dlrpContractedAmount',
          className: classes.capacityInTable,
          value: _.get(obj, 'committed_capacity', ''),
        }] : [],
        {
          id: 'homeOwnerName',
          className: classes.nameInTable,
          value: `${_.get(obj, 'home_owner_first_name', '-')} ${_.get(obj, 'home_owner_last_name', '')}`,
        },
        ...(program && program[0] && program[0].family_key === FAMILY_KEY.CT_ESS) ? [{
          id: 'utility',
          value: program.find(item => item.id === obj.program_id)?.utility_name,
        }, {
          id: 'committedCapacity',
          className: classes.centerAlign,
          value: _.get(obj, 'committed_capacity', ''),
        }] : [],
        ...(program && program[0] && program[0].program_key === PROGRAM_KEY.APS_RBP) ? [{
          id: 'installerName',
          className: classes.nameInTable,
          value: `${_.get(obj, 'installer_first_name', '-')} ${_.get(obj, 'installer_last_name', '')}`,
        }] : [],
        {
          id: 'applicationStatus',
          value: program && program[0] && program[0].family_key === FAMILY_KEY.CT_ESS ?
            <>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ width: '100%', mr: 1 }}>
                  <BorderLinearProgress classes={{ bar: (obj.application_status === 'Application_Rejected' || obj.application_status === 'Site_Rejected') && classes.rejectedBar }} variant="determinate" value={(tableApplicationStatus[program && program[0] && program[0].family_key] && tableApplicationStatus[program && program[0] && program[0].family_key][obj.application_status][4] / 4) * 100} />
                </Box>
                <Box className={classes.progressText}>
                  {`${tableApplicationStatus[program && program[0] && program[0].family_key] && tableApplicationStatus[program && program[0] && program[0].family_key][obj.application_status][4]}/4`}
                </Box>
              </Box>
              <Box display="flex" alignItems='center'>
                <div className={`${classes.round}`} style={{ background: tableApplicationStatus[program && program[0] && program[0].family_key] && tableApplicationStatus[program && program[0] && program[0].family_key][obj.application_status][1] }}></div>
                <Box className={classes.progressText} ml={0.5}>{tableApplicationStatus[program && program[0] && program[0].family_key] && tableApplicationStatus[program && program[0] && program[0].family_key][obj.application_status][0]}</Box>
              </Box>
            </>
            :
            _.get(obj, 'application_status', '') && <StatusButton className={classes.noXMargin} color={tableApplicationStatus[program && program[0] && program[0].program_key] && tableApplicationStatus[program && program[0] && program[0].program_key][obj.application_status][1]} text={tableApplicationStatus[program && program[0] && program[0].program_key] && tableApplicationStatus[program && program[0] && program[0].program_key][obj.application_status][0]} />,
        },
        ...(program && program[0] && program[0].program_key === PROGRAM_KEY.PSEG_LI || program && program[0] && program[0].program_key === PROGRAM_KEY.GMP_BYOD) ? [{
          id: 'timeStamp',
          className: classes.centerAlign,
          value: obj.last_modified_at && moment.utc(obj.last_modified_at).tz(timeZone).format('MMMM DD, YYYY h:mm A z'),
        }] : [],
        ...(program && program[0] && program[0].family_key === FAMILY_KEY.CT_ESS) ? [{
          id: 'date',
          value: obj.last_modified_at && moment.utc(obj.last_modified_at).tz(timeZone).format('MMMM DD, YYYY'),
        }] : [],
      ]
      applicationsTable.push(tableObj)
      return null
    })
    setTableData(applicationsTable)
  }

  const getFiles = (type) => {
    setLoading(true)
    const programIds = programId?.split(',')
    applicationsService.downloadFiles(programIds[0], type)
      .then(fileData => {
        setLoading(false)
        setOpen(true)
        if (pdfFiles.includes(type)) {
          let popUp = window.open(fileData.presigned_url, '_blank', '')
          if (popUp == null || typeof (popUp) == 'undefined') {
            setMessage('Please disable your pop-up blocker and download file again.')
            setMessageType(messageTypes.INFO)
          }
          else {
            setMessage('Files downloading')
            setMessageType(messageTypes.SUCCESS)
          }
        } else {
          downloadFile(fileData.presigned_url)
          setMessage('Files downloading')
          setMessageType(messageTypes.SUCCESS)
        }
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getFileContent = (key) => {
    switch (key) {
      case PROGRAM_KEY.PSEG_LI: {
        return (
          <Box>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography className={classes.fileModalText}>NYSERDA Customer Attestation Form.pdf</Typography>
              <Box className={classes.fileModalIcon} onClick={() => getFiles(PROGRAMDETAILS_FILES)}><img src={downloadFileIcon} alt="" /></Box>
            </Box>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography className={classes.fileModalText}>PSEG Enrolment Form.csv</Typography>
              <Box className={classes.fileModalIcon} onClick={() => getFiles(ENROLLMENT_FORMS)}><img src={downloadFileIcon} alt="" /></Box>
            </Box>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography className={classes.fileModalText}>Enphase Terms and Conditions Document.pdf</Typography>
              <Box className={classes.fileModalIcon} onClick={() => getFiles(TANDC_FORMS)}><img src={downloadFileIcon} alt="" /></Box>
            </Box>
          </Box>
        )
      }
      case FAMILY_KEY.CT_ESS: {
        return (
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography className={classes.fileModalText}>Enphase Terms and Conditions Document.pdf</Typography>
            <Box className={classes.fileModalIcon} onClick={() => getFiles(TANDC_FORMS)}><img src={downloadFileIcon} alt="" /></Box>
          </Box>
        )
      }
      default: {
        return (
          <Box display="flex" justifyContent="center" alignItems="center">
            <Box fontWeight="bold">No files found to download. Please select a valid program.</Box>
          </Box>
        )
      }
    }
  }

  useEffect(() => {
    if (program) {
      getAllApplications()
    }
  }, [page, rowsPerPage, headingStatus, program])

  useEffect(() => {
    getProgram()
  }, [programId])

  const renderApplicationsContent = () => (
    program && program[0] && program[0].program_key &&
    <TableOutline
      tableHeadings={tableHeadings(program && program[0] && program[0].program_key, classes)}
      tableData={tableData}
      loading={loading}
      totalElement={totalCount}
      pagination={totalCount > 0}
      page={page}
      rowsPerPage={rowsPerPage}
      handleDropdownChange={handleDropdownChange}
      selectedStatus={headingStatus}
      handleChangePage={handlePageChange}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
    />
  )

  return (
    <Box>
      <Loader loading={loading} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
      <Breadcrumb value={[{ 'Dashboard': '/' }, { [program && program[0] ? program[0].name : '']: `/applications`, search: urlProgram }]} />
      {processOpen && <Process open={processOpen} handleClose={() => setProcessOpen(false)} getFiles={getFiles} programId={programId} programKey={program && program[0] && program[0].family_key ? program[0].family_key : program[0].program_key} isFamilyKey={program && program[0] && program[0].family_key ? true : false} urlProgram={urlProgram} />}
      {programClosureModal && <ProgramClosureModal programClosureModal={programClosureModal} handleClose={setProgramClosureModal} />}
      {fileModal && <CustomDialog open={fileModal} title='Download Program Documents' content={getFileContent(program && program[0] && program[0].family_key ? program[0].family_key : program[0].program_key)} fullWidth maxWidth="xs" handleClose={() => setFileModal(false)} />}
      <Box className={classes.headerWrapper} display="flex" flexWrap="wrap">
        <Box display="flex" alignItems="center" flexWrap="wrap">
          <Typography className={classes.title}>Applications Tracker</Typography>
          {programClosure &&
            <Box className={classes.programClosureText} display="flex" alignItems="center" mx={1} onClick={() => setProgramClosureModal(true)}>
              <Box display="flex" alignItems="center" px={1} py={0.3}>Sorry! Not accepting applications anymore <KeyboardArrowRightIcon fontSize="small" /></Box>
            </Box>
          }
        </Box>
        <Box className={classes.buttonContainer}>
          {program && program[0] && program[0].family_key === FAMILY_KEY.CT_ESS &&
            <>
              <Tooltip title={<Box fontSize={14} p={1}>Download Program Documents</Box>} placement="top" arrow>
                <AppButton className={`${classes.mr4} ${classes.iconButtons}`} text={<img src={download} className={classes.buttonIcons} alt="" />} fill={false} onClick={() => setFileModal(true)} />
              </Tooltip>
              <Tooltip title={<Box fontSize={14} p={1}>See how application process works</Box>} placement="top" arrow>
                <AppButton className={`${classes.mr4} ${classes.iconButtons}`} text={<img src={processFlow} className={classes.buttonIcons} alt="" />} fill={false} onClick={() => setProcessOpen(true)} />
              </Tooltip>
            </>
          }
          {program && program[0] && program[0].program_key === PROGRAM_KEY.PSEG_LI && <AppButton className={`${classes.mr4} ${classes.buttons}`} text="Download Program Documents" fill={false} onClick={() => setFileModal(true)} />}
          {!programClosure && <AppButton className={`${classes.mr4} ${classes.buttons}`} text="Submit New Application" fill={program && program[0] && program[0].family_key ? true : false} onClick={() => props.history.push(`/applications/application-form?${urlProgram}`)} />}
          {program && program[0] && !program[0].family_key && <AppButton className={classes.buttons} text="See How Application Process Works" fill={false} onClick={() => setProcessOpen(true)} />}
        </Box>
      </Box>
      <Cards className={classes.cardWrapper} children={renderApplicationsContent()} />
    </Box>
  )
}

export default Applications